import { render, staticRenderFns } from "./blogsList.vue?vue&type=template&id=6f6bd426&scoped=true&"
import script from "./blogsList.vue?vue&type=script&lang=js&"
export * from "./blogsList.vue?vue&type=script&lang=js&"
import style0 from "./blogsList.vue?vue&type=style&index=0&id=6f6bd426&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6bd426",
  null
  
)

export default component.exports